import React from 'react';
// import ReactDom from 'react-dom';

export default class Email extends React.Component{
	constructor(props){
    super(props)
		this.state = {
			value: '',
			errorMsg: ''
		}
  }
  validateEmail(email) {
		var re = /^[a-zA-Z0-9+-._']+@[a-zA-Z0-9+-._']+\.[a-zA-Z]{2,}$/;
		return re.test(String(email).toLowerCase());
	}
  handleChange(e){
		let value = e.target.value
		this.setState({value})
  }
  validate(){
		// let that = this;
		if (!this.state.value){
			this.setState({
				errorMsg: 'Please enter your email'
			})
			return false;
		}else{
			if (!this.validateEmail(this.state.value)){
				this.setState({
					errorMsg: 'Your email is invalid'
				})
				return false
			}else{
        this.setState({errorMsg: ''}, function(){
					window.myForm.addHiddenFields({
						Email: this.state.value
					})
					this.props.setValue(this.state.value)
				})
				return true
      }
		}
  }
  render() {
    return (
			<div className={"field-wrapper" + (this.state.errorMsg ? ' invalid' : '')}>
        <label>Work Email Address</label>
				<input type="text" onChange={ e => this.handleChange(e)} onBlur={this.validate.bind(this)} autoComplete={ Math.random().toString(36).slice(2) } />
				<span className="error-msg">{this.state.errorMsg}</span>
			</div>
    )
  }
}